import { render, staticRenderFns } from "./prescribersDetails.vue?vue&type=template&id=5c4fd87c"
import script from "./prescribersDetails.vue?vue&type=script&lang=js"
export * from "./prescribersDetails.vue?vue&type=script&lang=js"
import style0 from "./prescribersDetails.vue?vue&type=style&index=0&id=5c4fd87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports